var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFallingFrameRight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 991 958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#97675e;}.cls-2{fill:#173856;}.cls-3{fill:#20456e;}.cls-4{fill:#639;}.cls-5{fill:#28110b;}.cls-6{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "au sol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_15",
    "data-name": "Calque 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bras_arri\\xE8re",
    "data-name": "bras arri\\xE8re"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M927.52,1469.84S907,1542.13,950.79,1539s33.31-70,33.31-70Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M934.11,1279.92s38.73-75.85,87.9-14.11L997.15,1477s-44.71,14.52-78-4C923.23,1397.83,934.11,1279.92,934.11,1279.92Z",
    transform: "translate(-508 -621)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1033.42,1475.26l-100.1-176.6s-24.65-43.5,32.77-76.05,77.14,2.26,77.14,2.26l105,185.31Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1355.32,1387.93s-171.71-14.22-229.64,26c26.69,32.41,3.75,102.38,26.73,105.08,34,4,92.11-12.07,92.11-12.07s80.24-20.45,121.32-10.38c0,0,6.67,7.84,16.15,8.19s57.47-5.14,57.47-5.14l-15.07-173.34S1341.29,1322.86,1355.32,1387.93Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1171.45,1533.83s96.06-37.21,192.25-16.1c5.31,13,81.24,11,81.24,11l4.7-170.51s-64.17-11.53-71.45,49.81c-53.94-10.31-198-20.1-257.2,4.17-2.9,29.88-86.25,34.54-88,62.79C1059,1576,1171.45,1533.83,1171.45,1533.83Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M970.63,1478.26s-7.59,74.74,34.94,64,20.64-74.69,20.64-74.69Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M944.12,1290.08s25-81.42,84.1-29.17l12.23,212.27s-41.51,22.07-77.5,9.65C953.9,1408.08,944.12,1290.08,944.12,1290.08Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M939.34,1243.58c5.8-7.2,14.17-14.41,26.07-21.15,57.42-32.55,78.88,1.27,78.88,1.27S1018.91,1209.34,939.34,1243.58Z",
    transform: "translate(-508 -621)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1022.18,
    y: 1435.05,
    width: 132,
    height: 8,
    transform: "translate(-1076.08 102.65) rotate(-29.54)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 499,
    cy: 419,
    r: 169
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M967.5,1124.5l-10,77.13C940.92,1216,776.79,1173.54,813.7,984.5c2.6-13.31,14-39,29-65-46,0-86,218-160,260-60.69-74-70.11-364.45,110-343,21,3,60,34,63.78,67.17,41.89-39.67,105.21-50.55,161-46.17,26.27,2.06,70.79,18.2,101,41a196,196,0,0,1,49,55c17.2,34-21.82,88.28-111.8,61-13.92,34.16-29.92,57-49.2,62,0,0-27.67-26.15-54-14C926.5,1074.5,932.5,1128.5,967.5,1124.5Z",
    transform: "translate(-508 -621)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_9",
    "data-name": "Calque 9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 991,
    height: 958
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallingFrameRight2);
export default __webpack_public_path__ + "static/media/falling_frame_right_2.44c002373a980f1c8314a95af9106003.svg";
export { ForwardRef as ReactComponent };